import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import moment from 'moment';

import Button from '../../../components/shared/Button/Button';
import Modal from '../../../components/shared/Modal/Modal';
import { IsMobile } from '../../../helpers/IsMobile';

import styles from './CloseDispute.module.scss';

const CloseDispute = ({ show, onHide, handleSubmit, data }) => {
  const { t } = useTranslation('common');
  const modalFullScreen = IsMobile();

  return (
    <Modal show={show} onHide={onHide} size="lg" centered fullscreen={modalFullScreen}>
      <Modal.CustomHeader closeButton>
        <Modal.Title>{t('dispute.closeDispute')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <div className={styles.bodyCont}>
          <div className={styles.contentCont}>
            <div className={styles.infoCont}>
              <div className={styles.infoBlock}>
                <p className={styles.infoHeading}>{t('dispute.companyName')}</p>
                <p className={classNames(styles.infoText, styles.textHeavy)}>{data.employer}</p>
              </div>
            </div>
            <div className={styles.infoCont}>
              <div className={styles.infoBlock}>
                <p className={styles.infoHeading}>{t('dispute.candidateNameLabel')}</p>
                <p className={styles.infoText}>{data.candidate}</p>
              </div>
              <div className={classNames(styles.infoBlock, styles.blockPadding)}>
                <p className={styles.infoHeading}>{t('dispute.openingTitleLabel')}</p>
                <p className={styles.infoText}>{data.opening}</p>
              </div>
            </div>
            <div className={styles.infoCont}>
              <div className={styles.infoBlock}>
                <p className={styles.infoHeading}>{t('dispute.disputeId')}</p>
                <p className={styles.infoText}>{data.uuid}</p>
              </div>
              <div className={classNames(styles.infoBlock, styles.blockPadding)}>
                <p className={styles.infoHeading}>{t('dispute.disputeDate')}</p>
                <p className={styles.infoText}>{moment(data.created_at).format('MM/DD/YY')}</p>
              </div>
            </div>
          </div>
          <p className={styles.text}>
            {t('dispute.closeWarning')}
            <br /> {t('dispute.confirmProceed')}
          </p>
        </div>
      </Modal.Body>
      <Modal.CustomFooter>
        <div className={styles.actionCont}>
          <Button variant="primary" onClick={() => handleSubmit(data.id)}>
            {t('submit')}
          </Button>
          <Button variant="outline-secondary" onClick={onHide}>
            {t('cancel')}
          </Button>
        </div>
      </Modal.CustomFooter>
    </Modal>
  );
};

export default CloseDispute;
